import React, { useState } from "react";

export default function Person({ animate, person }) {
  const [imageLoaded, setImageLoaded] = useState(false); // Etat pour vérifier si l'image est chargée
  const [imageError, setImageError] = useState(false); // Etat pour vérifier si l'image a échoué à se charger

  // Handler appelé quand l'image est correctement chargée
  const handleImageLoad = () => {
    setImageLoaded(true); // L'image est bien chargée
  };

  // Handler appelé quand l'image échoue à se charger
  const handleImageError = () => {
    setImageError(true); // L'image n'a pas pu être chargée
  };

  return (
    <>
      {person.image && !imageError ? (
        <img
          src={person.image}
          className={`tyn-media img ${animate ? animate : ""}`}
          alt={"avatar_user_online__" + person.nom}
          style={{ cursor: "pointer" }}
          onLoad={handleImageLoad} // Déclenchement quand l'image se charge
          onError={handleImageError} // Déclenchement quand l'image échoue à se charger
        />
      ) : (
        !imageLoaded && (
          <div
            className={`text-uppercase ${animate ? animate : " tyn-media img"}`}
            style={{
              cursor: "pointer",
              backgroundColor: person.colors?.background || "pink",
              color: person.colors?.text || "red",
              height: animate ? "100%" : null,
              width: animate ? "100%" : null,
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              borderRadius: "10px",
              fontSize: "150%",
            }}
          >
            {(person.prenom || "").charAt(0) + (person.nom || "").charAt(0)}
          </div>
        )
      )}
    </>
  );
}
